module.exports = __webpack_public_path__ + "img/peach_and_glitter.4ad6755a.jpg";